/**
 * @generated SignedSource<<2ce081e11a33c8faa50d9579c2730695>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftPdpExhibitionNotes_nftItem$data = {
  readonly exhibitionNotes: {
    readonly contentList: ReadonlyArray<{
      readonly __typename: "NftExhibitionNoteImageListContent";
      readonly " $fragmentSpreads": FragmentRefs<"NftPdpExhibitionNoteImageList_note">;
    } | {
      readonly __typename: "NftExhibitionNoteRichTextContent";
      readonly " $fragmentSpreads": FragmentRefs<"NftPdpExhibitionNoteRichText_note">;
    } | {
      readonly __typename: "NftExhibitionNoteVideoEmbedContent";
      readonly " $fragmentSpreads": FragmentRefs<"NftPdpExhibitionNoteVideo_note">;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null> | null;
  } | null;
  readonly " $fragmentType": "NftPdpExhibitionNotes_nftItem";
};
export type NftPdpExhibitionNotes_nftItem$key = {
  readonly " $data"?: NftPdpExhibitionNotes_nftItem$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftPdpExhibitionNotes_nftItem">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NftPdpExhibitionNotes_nftItem",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "NftExhibitionNote",
      "kind": "LinkedField",
      "name": "exhibitionNotes",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "contentList",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__typename",
              "storageKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "NftPdpExhibitionNoteImageList_note"
                }
              ],
              "type": "NftExhibitionNoteImageListContent",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "NftPdpExhibitionNoteRichText_note"
                }
              ],
              "type": "NftExhibitionNoteRichTextContent",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "NftPdpExhibitionNoteVideo_note"
                }
              ],
              "type": "NftExhibitionNoteVideoEmbedContent",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "NftItem",
  "abstractKey": null
};

(node as any).hash = "f866449de7ff8e5e4cb1f1f60b8a885f";

export default node;
